import { parseNoteHtml } from './parseNoteHtml';
import { serializeBlocks } from './serializeBlocks';

// Canonicalization IS parse→serialize: tag mapping, junk stripping, run
// merging, nesting order, and list grouping all fall out of the IR round-trip.
export const normalizeNoteHtml = (html) => serializeBlocks(parseNoteHtml(html));
